export default {
  // ===== Common =====
  "drama.common.cancel": "Cancel",
  "drama.common.confirm": "Confirm",
  "drama.common.save": "Save",
  "drama.common.edit": "Edit",
  "drama.common.delete": "Delete",
  "drama.common.irreversibleHint": "This action cannot be undone",
  "drama.common.refresh": "Refresh",
  "drama.common.detail": "Detail",
  "drama.common.preview": "Preview",
  "drama.common.empty": "—",
  "drama.common.untitled": "Untitled",
  "drama.common.project": "Project",

  // ===== Workspace tab (reused by canvas SidebarTabBar) =====
  "drama.workspace.tab.overview": "Overview",
  "drama.workspace.tab.project": "Project",
  // Assets = merged Characters + Scenes entry; sub-tabs still use the existing labels.
  "drama.workspace.tab.assets": "Assets",
  "drama.workspace.tab.characters": "Characters",
  "drama.workspace.tab.scenes": "Scenes",
  "drama.workspace.tab.episodes": "Storyboards",
  "drama.workspace.share": "Share",

  // ===== Canvas (default main stage + fullscreen layout) =====
  "drama.canvas.backToProjectList": "Back to projects",
  "drama.overview.gotoCanvas": "Open canvas",

  // ===== Project status (ProjectStatusTag) =====
  "drama.projectStatus.draft": "Draft",
  "drama.projectStatus.parsing": "Parsing",
  "drama.projectStatus.parsed": "Parsed",
  "drama.projectStatus.extractingChars": "Extracting Characters",
  "drama.projectStatus.charactersReady": "Characters Ready",
  "drama.projectStatus.extractingScenes": "Extracting Scenes",
  "drama.projectStatus.scenesReady": "Scenes Ready",
  "drama.projectStatus.failed": "Failed",

  // ===== Projects list page =====
  "drama.projects.title": "Projects",
  "drama.projects.newButton": "New Project",
  "drama.projects.createCardTitle": "Start creating",
  "drama.projects.untitled": "Untitled Project",
  "drama.projects.editedJustNow": "Edited just now",
  "drama.projects.editedMinutesAgo": "Edited {count} minutes ago",
  "drama.projects.editedHoursAgo": "Edited {count} hours ago",
  "drama.projects.editedDaysAgo": "Edited {count} days ago",
  "drama.projects.editedAt": "Edited at {time}",
  "drama.projects.loadFailed": "Failed to load projects",
  "drama.projects.createFailed": "Failed to create",
  "drama.projects.createSuccess":
    "Created. Open the workspace to paste the project body.",
  "drama.projects.deleteConfirm": "Delete this project?",
  "drama.projects.deleteWarning":
    "All related episodes, scenes and characters will be deleted permanently.",
  "drama.projects.deleteSuccess": "Deleted",
  "drama.projects.deleteFailed": "Failed to delete",
  "drama.projects.emptyHint":
    'No projects yet. Click "New Project" in the top right to start.',
  "drama.projects.totalCount": "{count} projects in total",
  "drama.projects.epLabel": "Eps",
  "drama.projects.sceneLabel": "Scenes",
  "drama.projects.charLabel": "Characters",
  "drama.projects.menuOpen": "Open",
  "drama.projects.menuDelete": "Delete",
  "drama.projects.newModalTitle": "New Project",
  "drama.projects.newModalOk": "Create & Open",
  "drama.projects.formTitle": "Title",
  "drama.projects.formTitleRequired": "Please enter a project title",
  "drama.projects.formTitleMaxLength": "Up to 80 characters",
  "drama.projects.formTitlePlaceholder": "e.g. Foggy Harbour 1924",

  // ===== Workspace - Overview =====
  "drama.overview.untitledProject": "Untitled Project",
  "drama.overview.missingHint": "One step left: {hint}",
  "drama.overview.checklist.parse": "Episodes & scenes split",
  "drama.overview.checklist.parseHint":
    'Paste the project and click "1. Split Episodes/Scenes".',
  "drama.overview.checklist.charsDone": "Characters extracted ({count})",
  "drama.overview.checklist.charsTodo": "Extract characters",
  "drama.overview.checklist.charsHint":
    'After splitting, click "2. Extract Characters".',
  "drama.overview.checklist.scenesDone": "Scene pool extracted ({count})",
  "drama.overview.checklist.scenesTodo": "Extract scene pool",
  "drama.overview.checklist.scenesHint":
    'After characters, click "3. Extract Scene Pool".',
  "drama.overview.saveFailed": "Failed to save",
  "drama.overview.saveSuccess": "Saved",
  "drama.overview.parseSuccess": "Episodes & scenes split done",
  "drama.overview.parseFailed": "Failed to split",
  "drama.overview.parseEmptyContent":
    "Project body is empty. Please paste content first.",
  "drama.overview.parseRunning": "Splitting episodes & scenes…",
  "drama.overview.extractCharsSuccess": "Characters extracted",
  "drama.overview.extractCharsFailed": "Failed to extract characters",
  "drama.overview.extractScenesSuccess": "Scenes extracted",
  "drama.overview.extractScenesFailed": "Failed to extract scenes",
  "drama.overview.extractCharsStarted":
    "Character extraction queued — runs ~1-2 min in background; you can navigate away.",
  "drama.overview.extractScenesStarted":
    "Scene extraction queued — runs ~1-2 min in background; you can navigate away.",
  "drama.overview.charsExtractReady": "Characters ready — {total} found",
  "drama.overview.scenesExtractReady": "Scenes ready — {total} found",
  "drama.overview.resetConfirm": "Reset project?",
  "drama.overview.resetWarning":
    "This clears episodes, scenes and characters. The raw text is kept.",
  "drama.overview.resetSuccess": "Reset done. Re-parse anytime.",
  "drama.overview.resetFailed": "Failed to reset",
  "drama.overview.contentPlaceholder":
    "Paste project body here (drag & drop .docx supported)",
  "drama.overview.uploadDocx": "Upload .docx",
  "drama.overview.parseButton": "1. Split Episodes/Scenes",
  "drama.overview.extractCharsButton": "2. Extract Characters",
  "drama.overview.extractScenesButton": "3. Extract Scene Pool",
  "drama.overview.resetButton": "Reset",
  "drama.overview.contentTitle": "Project Body",
  "drama.overview.flowTitle": "Pipeline",
  "drama.overview.metaCardTitle": "Metadata",
  "drama.overview.metaEditButton": "Edit",
  "drama.overview.metaEra": "Era",
  "drama.overview.metaGenre": "Genre",
  "drama.overview.metaEpisodes": "Planned Episodes",
  "drama.overview.metaLocation": "Location",
  "drama.overview.metaSynopsis": "Synopsis",
  "drama.overview.metaSynopsisEmpty":
    'No synopsis yet — click "Edit" to add one.',
  "drama.overview.metaEpisodesTag": "{count} ep",
  "drama.overview.statEpisodes": "Episodes",
  "drama.overview.statScenes": "Scenes",
  "drama.overview.statCharacters": "Characters",
  "drama.overview.statScenePool": "Scene Pool",
  "drama.overview.contentCardTitle": "Project Body",
  "drama.overview.contentEdit": "Edit Body",
  "drama.overview.contentPaste": "Paste / Import",
  "drama.overview.contentSave": "Save",
  "drama.overview.contentCancel": "Cancel",
  "drama.overview.contentSaveSuccess": "Body saved",
  "drama.overview.contentEmpty":
    'No body yet. Click "Paste / Import" in the top right to enable splitting.',
  "drama.overview.projectNotFound": "Project not found",
  "drama.overview.parseTooShort": "Please fill ≥ {min} chars first.",
  "drama.overview.parseExistingTip":
    'Existing episodes are kept. To re-parse the whole project, use "Reset" first.',
  "drama.overview.parseIncrementalRetryTip":
    "This run will automatically re-parse {failed} failed episode(s) (LLM timeouts/errors) — successful episodes are kept untouched.",
  "drama.overview.parseStatus.label": "Parse status:",
  "drama.overview.parseStatus.ok": "{count} ok",
  "drama.overview.parseStatus.partial": "{count} partial",
  "drama.overview.parseStatus.partialHint":
    'These episodes have partial scene data. Incremental parse will NOT re-run them (to avoid overwriting edits you may have made). Use "Reset" if you want a clean redo.',
  "drama.overview.parseStatus.failed": "{count} failed",
  "drama.overview.parseStatus.failedHint":
    'Just click "Incremental Parse": the backend will clear the failed placeholders and only re-run LLM on those episodes. Other successful episodes stay untouched.',
  "drama.overview.parseStatus.unknown": "{count} unknown",
  "drama.overview.charsExistingTip":
    'Existing character fields are not updated. To re-extract everything, use "Reset" first.',
  "drama.overview.scenesExistingTip":
    'Existing scene fields are not updated. To re-extract everything, use "Reset" first.',
  "drama.overview.enrichInProgressTip":
    "Project is enriching plot details in the background (LLM ~1-3 min). Extract characters / scenes available once it finishes.",
  "drama.overview.parseFirstButton": "1. Split Episodes/Scenes",
  "drama.overview.parseIncrementalButton": "1. Incremental Parse",
  "drama.overview.parseStartedFirst":
    "Parsing started, the page will refresh automatically.",
  "drama.overview.parseStartedIncremental":
    "Incremental parse started: existing episodes are kept, only new ones are added.",
  "drama.overview.charsFirstButton": "2. Extract Characters",
  "drama.overview.charsIncrementalButton":
    "2. Extract Characters (Incremental)",
  "drama.overview.charsExtractFirst": "Extracted {count} characters",
  "drama.overview.charsExtractAdded":
    "{added} added this round, {total} in total",
  "drama.overview.charsExtractNoChange": "Already up to date, {total} in total",
  "drama.overview.scenesFirstButton": "3. Extract Scene Pool",
  "drama.overview.scenesIncrementalButton": "3. Extract Scenes (Incremental)",
  "drama.overview.scenesExtractFirst": "Extracted {count} scenes",
  "drama.overview.scenesExtractAdded":
    "{added} added this round, {total} in total",
  "drama.overview.scenesExtractNoChange":
    "Already up to date, {total} in total",
  "drama.overview.flowCardTitle": "Pipeline",
  "drama.overview.resetMenuLabel": "Reset Project (clear all)",
  "drama.overview.resetModalTitle": "Reset this project?",
  "drama.overview.resetModalContent":
    "Episodes / characters / prompts / images / sheets / scenes will be cleared. Raw text and meta are kept.",
  "drama.overview.resetOk": "Reset",
  "drama.overview.metaSaveSuccess": "Info updated",
  "drama.overview.progressOverview": "Progress",
  "drama.overview.progressEpScene": "Episodes / Scenes: {ep} / {scene}",
  "drama.overview.progressChars": "Characters: {count}",
  "drama.overview.progressScenePool": "Scene Pool: {count}",
  "drama.overview.gotoEpisodes": "Episodes",
  "drama.overview.gotoCharacters": "Characters",
  "drama.overview.gotoScenes": "Scenes",
  "drama.overview.metaModalTitle": "Edit Project Info",
  "drama.overview.metaForm.title": "Title",
  "drama.overview.metaForm.titleRequired": "Please enter a title",
  "drama.overview.metaForm.titleMax": "Up to 80 chars",
  "drama.overview.metaForm.synopsis": "Synopsis",
  "drama.overview.metaForm.synopsisPlaceholder":
    "A short summary; the cover poster prompt is based on this.",
  "drama.overview.metaForm.era": "Era",
  "drama.overview.metaForm.eraPlaceholder":
    "e.g. 1990s / Republic / near future",
  "drama.overview.metaForm.genre": "Genre (press Enter to add tags)",
  "drama.overview.metaForm.genrePlaceholder": "e.g. urban, mystery",
  "drama.overview.metaForm.location": "Location",
  "drama.overview.metaForm.locationPlaceholder":
    "e.g. Shanghai / Beijing / fictional town",
  "drama.overview.metaForm.episodes": "Planned Episodes",

  // ===== Workspace - Characters =====
  "drama.characters.pageTitle": "Character Pool",
  "drama.characters.pageSubtitle":
    "All appearing characters; main covers and prompts start here.",
  "drama.characters.untitled": "Unnamed Character",
  "drama.characters.role.main": "Lead",
  "drama.characters.role.support": "Supporting",
  "drama.characters.role.extra": "Extra",
  "drama.characters.status.draft": "Cover Pending",
  "drama.characters.status.canonicalReady": "Cover Ready",
  "drama.characters.status.promptsReady": "Prompts Ready",
  "drama.characters.status.generating": "Generating",
  "drama.characters.status.datasetReady": "Assets Ready",
  "drama.characters.status.loraReady": "LoRA Trained",
  "drama.characters.extractButton": "Extract Characters",
  "drama.characters.extractTooltipNeedParse":
    "Finish episodes/scenes split in Overview first.",
  "drama.characters.newButton": "Add Character",
  "drama.characters.loraWorkspaceButton": "LoRA Workspace",
  "drama.characters.emptyHint":
    'No characters yet. Click "Extract Characters" for LLM auto-detect, or "Add Character" to add manually.',
  "drama.characters.extractFailed": "Failed to extract characters",
  "drama.characters.extractStarted":
    "Character extraction queued — check Overview for progress.",
  "drama.characters.batchGenCanonical": "Generate All Portraits",
  "drama.characters.batchGenCanonicalStarted":
    "Queued {started} portrait jobs, skipped {skipped} (already done or in flight)",
  "drama.characters.batchGenCanonicalNothing":
    "All character portraits are ready or in flight",
  "drama.characters.batchGenCanonicalFailed":
    "Failed to start batch portrait generation",
  "drama.characters.extractFirst": "Extracted {count} characters",
  "drama.characters.extractAdded": "{added} new this round, {total} in total",
  "drama.characters.extractNoChange": "Already up to date, {total} in total",
  "drama.characters.createSuccess": "Character added",
  "drama.characters.createFailed": "Failed to add character",
  "drama.characters.createModalTitle": "Add Character",
  "drama.characters.createOk": "Create",
  "drama.characters.formLabel.name": "Name",
  "drama.characters.formError.nameRequired": "Name is required",
  "drama.characters.formError.nameTooLong": "Up to 40 characters",
  "drama.characters.formPlaceholder.name": "e.g. Lin Xiumei",
  "drama.characters.formLabel.role": "Role",
  "drama.characters.formLabel.gender": "Gender",
  "drama.characters.formPlaceholder.gender": "female / male",
  "drama.characters.formLabel.ageRange": "Age Range",
  "drama.characters.formPlaceholder.ageRange": "e.g. 25-30",
  "drama.characters.formLabel.profile": "Profile",
  "drama.characters.formTooltip.profile":
    "Personality + key background, ≤ 50 chars works best. Not used directly in cover prompt, but useful for reference.",
  "drama.characters.formLabel.appearance": "Appearance",
  "drama.characters.formTooltip.appearance":
    "Hairstyle / face / body / signature features. Used directly in cover prompt.",
  "drama.characters.formPlaceholder.appearance":
    "e.g. medium-long black hair, oval face, scar above left brow",
  "drama.characters.formLabel.outfit": "Default Outfit",
  "drama.characters.formTooltip.outfit":
    "Most common outfit (fabric/color/style), used in cover prompt.",
  "drama.characters.formPlaceholder.outfit": "e.g. navy canvas worker jacket",
  "drama.characters.formLabel.outfitVariants": "Outfit Variants",
  "drama.characters.formTooltip.outfitVariants":
    "2-3 outfit variants, used when generating outfit Sheet.",
  "drama.characters.formPlaceholder.outfitVariants": "Press Enter to add",

  // ===== Character detail =====
  "drama.character.shotStatus.pending": "Generating",
  "drama.character.shotStatus.processing": "Generating",
  "drama.character.shotStatus.completed": "Completed",
  "drama.character.shotStatus.failed": "Failed",
  "drama.character.shotStatus.canceled": "Canceled",
  "drama.character.canonicalStatus.pending": "Generating",
  "drama.character.canonicalStatus.processing": "Generating",
  "drama.character.canonicalStatus.completed": "Ready",
  "drama.character.canonicalStatus.failed": "Failed",
  "drama.character.canonicalStatus.canceled": "Canceled",
  "drama.character.sheetRegenConfirm": "Regenerate {name}?",
  "drama.character.sheetRegenWarning":
    "Generates another sheet of the same kind; old ones are kept in history.",
  "drama.character.regenButton": "Regenerate",
  "drama.character.cancelButton": "Cancel",
  "drama.character.genCanonical": "Generate Cover",
  "drama.character.regenCanonical": "Regenerate Cover",
  "drama.character.canonicalReady": "Cover Ready",
  "drama.character.canonicalFailed": "Cover generation failed",
  "drama.character.canonicalProcessing": "Generating cover…",
  "drama.character.genPrompts": "Generate Prompt Matrix",
  "drama.character.batchGenerate": "Batch Generate",
  "drama.character.exportDataset": "Export Dataset Zip",
  "drama.character.tabs.canonical": "Cover",
  "drama.character.tabs.prompts": "Prompt Matrix",
  "drama.character.tabs.gallery": "Gallery",
  "drama.character.tabs.sheets": "Sheets",
  "drama.character.tabs.lora": "LoRA",
  "drama.character.notFound": "Character not found",
  "drama.character.headerTitle": "{name} · LoRA Workspace",
  "drama.character.profileCardTitle": "Character Profile",
  "drama.character.editButton": "Edit",
  "drama.character.canonicalNotGenerated": "Not generated",
  "drama.character.genCanonicalButton": "Generate Cover",
  "drama.character.descLabel.gender": "Gender",
  "drama.character.descLabel.age": "Age",
  "drama.character.descLabel.profile": "Profile",
  "drama.character.descLabel.appearance": "Appearance",
  "drama.character.descLabel.outfit": "Default Outfit",
  "drama.character.descLabel.outfitVariants": "Outfit Variants",
  "drama.character.descLabel.sceneCount": "Scenes",
  "drama.character.metricsCardTitle": "Pipeline Metrics",
  "drama.character.metricsSelectedRate": "Pending selection rate",
  "drama.character.metricsGenProgress": "Generation progress",
  "drama.character.actionsCardTitle": "Actions",
  "drama.character.exportDatasetButton": "Export LoRA Dataset ({count})",
  "drama.character.refreshButton": "Refresh",
  "drama.character.sheetKitTitle":
    "LoRA Training Sheets ({completed} / {total} ready)",
  "drama.character.sheetKitRegenConfirm": "Regenerate full LoRA sheet kit?",
  "drama.character.sheetKitRegenDesc": "Resubmits all 6 sheet tasks.",
  "drama.character.sheetKitRegenOk": "Start",
  "drama.character.sheetKitCancel": "Cancel",
  "drama.character.sheetKitGenAllButton": "Generate Full Kit (6 sheets)",
  "drama.character.sheetKitNeedCanonical": "Generate the cover first",
  "drama.character.llmPromptsTitle": "LLM Prompts ({count})",
  "drama.character.genCountLabel": "Count",
  "drama.character.regenPromptsConfirm": "Regenerate prompts?",
  "drama.character.regenPromptsDesc":
    "Pending (non-generated) prompt drafts will be cleared; already-generated ones are kept.",
  "drama.character.regenPromptsOk": "Regenerate",
  "drama.character.aiGenPromptsButton": "AI Generate Prompts",
  "drama.character.batchConfirm": "Submit batch generate?",
  "drama.character.batchDesc": "Will generate for {count} selected prompts.",
  "drama.character.batchOk": "Start",
  "drama.character.batchButton": "Batch Generate ({count})",
  "drama.character.noLLMPrompts": "No LLM prompts yet",
  "drama.character.bulkSelectInfo": "Pending {pending} · Selected {selected}",
  "drama.character.bulkSelectAllPending": "Select all pending",
  "drama.character.bulkClearAll": "Clear selection",
  "drama.character.donePromptsTag": "Done",
  "drama.character.selectCheckbox": "Select",
  "drama.character.bulkSelectFailed": "{ok}/{total} updated, {failed} failed",
  "drama.character.sceneTagPrefix": "Scene {key}",
  "drama.character.viewKeyMain": "Cover",
  "drama.character.llmShotsTitle": "LLM Shots ({count})",
  "drama.character.noLLMShots": "No LLM shots yet",
  "drama.character.shotFailed": "Failed",
  "drama.character.editModalTitle": "Edit Character · {name}",
  "drama.character.formLabel.name": "Name",
  "drama.character.formLabel.role": "Role",
  "drama.character.formLabel.gender": "Gender",
  "drama.character.formLabel.ageRange": "Age Range",
  "drama.character.formLabel.profile": "Profile",
  "drama.character.formLabel.appearance": "Appearance",
  "drama.character.formLabel.outfit": "Default Outfit",
  "drama.character.formLabel.outfitVariants": "Outfit Variants",
  "drama.character.formLabel.regenCanonical": "Regenerate Cover",
  "drama.character.formError.nameRequired": "Name is required",
  "drama.character.formError.nameTooLong": "Up to 40 characters",
  "drama.character.formPlaceholder.gender": "female / male",
  "drama.character.formPlaceholder.ageRange": "e.g. 25-30",
  "drama.character.formPlaceholder.outfitVariants": "Press Enter to add",
  "drama.character.formTooltip.profile":
    "Personality + key background, ≤ 50 chars works best.",
  "drama.character.formTooltip.appearance":
    "Hairstyle / face / body / signature features. Regenerate cover after editing for it to take effect.",
  "drama.character.formTooltip.outfit":
    "Most common outfit (fabric/color/style). Regenerate cover after editing for it to take effect.",
  "drama.character.formTooltip.outfitVariants":
    "2-3 outfit variants, used to fill 9 cells when generating outfit Sheet.",
  "drama.character.formTooltip.regenCanonical":
    "Only needed after editing fields that affect generation (appearance / outfit). Overwrites the current cover.",
  "drama.character.regenCanonicalConfirm": "Regenerate character cover?",
  "drama.character.regenCanonicalWarning": "Current cover will be overwritten.",
  "drama.character.regenCanonicalOk": "Regenerate",
  "drama.character.regenCanonicalButton": "Regenerate Cover",
  "drama.character.editScenePopoverTitle": "Edit Scene Binding",
  "drama.character.editSceneButton": "Edit Scene",
  "drama.character.previewSceneButton": "Preview Scene",
  "drama.character.sceneSelectLabel": "Scene",
  "drama.character.scenePlaceholder": "No scene bound",
  "drama.character.viewSelectLabel": "View",
  "drama.character.sheetNotReady": "Four-view not ready",
  "drama.character.viewPlaceholderNoScene": "Select a scene first",
  "drama.character.viewPlaceholderNotReady": "Scene four-view not ready",
  "drama.character.viewPlaceholderUnspecified": "Unspecified angle",
  "drama.character.cancelPopoverButton": "Cancel",
  "drama.character.saveButton": "Save",
  "drama.character.regenLabel": "Regen",
  "drama.character.deleteSheetLabel": "Delete",
  "drama.character.deleteSheetConfirm": "Delete {name}?",
  "drama.character.deleteSheetWarning":
    "After deletion, none of this sheet's cells will go into the dataset export.",
  "drama.character.genButton": "Generate",
  "drama.character.cellTitleFmt": "cell {idx}",
  "drama.character.viewLargeButton": "View Large",
  "drama.character.shotFailedFallback": "Generation failed",
  "drama.character.exportFailMsg": "Failed to export",
  "drama.character.exportTooLowTitle": "Training set is small",
  "drama.character.exportTooLowContent":
    "Current {total} images. 20+ recommended. Export anyway?",
  "drama.character.canonicalGenSuccess":
    "Cover generation submitted, please wait.",
  "drama.character.canonicalGenFailed": "Cover generation failed",
  "drama.character.savedProfile": "Character profile updated",
  "drama.character.saveProfileFailed": "Failed to save",
  "drama.character.genPromptsSuccess": "Generated {count} prompts",
  "drama.character.genPromptsFailed": "Generation failed",
  "drama.character.sheetKitSuccess": "Sheet kit submitted: {count} sheets",
  "drama.character.sheetKitFailed": "Sheet kit generation failed",
  "drama.character.sheetGenSuccess": "Submitted, waiting for generation",
  "drama.character.sheetGenFailed": "Generation failed",
  "drama.character.opFailed": "Operation failed",
  "drama.character.sheetDeleteFailed": "Failed to delete",
  "drama.character.batchSuccess": "{submitted} tasks submitted{failedSuffix}",
  "drama.character.batchFailedSuffix": ", {failed} failed",
  "drama.character.batchFailed": "Batch generation failed",
  "drama.character.scenePatchSuccess": "Scene binding updated",
  "drama.character.scenePatchFailed": "Failed to update",

  // ===== Workspace - Scenes =====
  "drama.scenes.poolTitle": "Scene Pool ({count})",
  "drama.scenes.untitledScene": "Unnamed Scene",
  "drama.scenes.sheetGenerating": "Generating four-view…",
  "drama.scenes.sheetStatus.pending": "Generating",
  "drama.scenes.sheetStatus.processing": "Generating",
  "drama.scenes.sheetStatus.completed": "Generated",
  "drama.scenes.sheetStatus.failed": "Failed",
  "drama.scenes.sheetStatus.canceled": "Canceled",
  "drama.scenes.cellLabel.wideEstablishing": "Wide Establishing",
  "drama.scenes.cellLabel.mainActivity": "Main Activity",
  "drama.scenes.cellLabel.dialogFront": "Dialog Front",
  "drama.scenes.cellLabel.dialogReverse": "Dialog Reverse",
  "drama.scenes.appearanceCount": "Appearances {count}",
  "drama.scenes.extractButton": "Extract Scene Pool",
  "drama.scenes.extractTooltipNeedParse":
    "Finish episodes/scenes split in Overview first.",
  "drama.scenes.emptyHint":
    'No scenes yet. Click "Extract Scene Pool" in the top right to start.',
  "drama.scenes.extractFirst": "Extracted {count} scenes",
  "drama.scenes.extractAdded": "{added} new this round, {total} in total",
  "drama.scenes.extractNoChange": "Already up to date, {total} in total",
  "drama.scenes.extractFailed": "Failed to extract scenes",
  "drama.scenes.extractStarted":
    "Scene extraction queued — check Overview for progress.",
  "drama.scenes.batchGenCanonicalMaster": "Generate All Scene Images",
  "drama.scenes.batchGenCanonicalMasterStarted":
    "Queued {started} scene image jobs, skipped {skipped} (already done or in flight)",
  "drama.scenes.batchGenCanonicalMasterNothing":
    "All scene images are ready or in flight",
  "drama.scenes.batchGenCanonicalMasterFailed":
    "Failed to start batch scene image generation",
  "drama.scenes.genSheetSuccess": "Four-view generation task submitted",
  "drama.scenes.genSheetFailed": "Failed to generate four-view",
  "drama.scenes.editSuccess": "Scene metadata saved",
  "drama.scenes.editFailed": "Failed to save",
  "drama.scenes.regenConfirm": "Regenerate scene four-view?",
  "drama.scenes.regenWarning": "The current four-view will be overwritten.",
  "drama.scenes.regenOk": "Regenerate",
  "drama.scenes.regenButton": "Regenerate Four-view",
  "drama.scenes.genButton": "Generate Four-view",
  "drama.scenes.editButton": "Edit",
  "drama.scenes.visualV2Button": "Visual Consistency V2",
  // ==== Scene Visual Consistency V2 (multi-kind sheet + panorama) ====
  "drama.sceneV2.drawer.title": "Visual Consistency · {name}",
  "drama.sceneV2.tab.canonical": "Anchor",
  "drama.sceneV2.tab.kinds": "Multi-view",
  "drama.sceneV2.tab.extra": "Extra views",
  "drama.sceneV2.tab.panorama": "Panorama",

  "drama.sceneV2.canonical.tipTitle":
    "Scene anchor — visual ground truth for derived images",
  "drama.sceneV2.canonical.tipDesc":
    'Generate one polished master shot as the "environment anchor" for this scene. All subsequent multi-view sheets, extra views and cross-shot continuity will use it as Ref#1 to lock space/material/color. Same idea behind Kling 3.0 / Sora cref.',
  "drama.sceneV2.canonical.gen": "Generate Anchor",
  "drama.sceneV2.canonical.regen": "Regenerate Anchor",
  "drama.sceneV2.canonical.processing": "Generating…",
  "drama.sceneV2.canonical.empty": "No anchor yet",
  "drama.sceneV2.canonical.intro":
    "The anchor defines this scene's room layout, wall materials, key props and lighting direction. After regenerating the anchor, existing sheets and extra views are NOT auto-rebuilt; rerun them as needed.",
  "drama.sceneV2.canonical.genStarted": "Anchor generation submitted",
  "drama.sceneV2.canonical.genFailed": "Anchor generation failed",

  "drama.sceneV2.kinds.canonicalRequiredTitle": "Anchor required",
  "drama.sceneV2.kinds.canonicalRequiredDesc":
    'Every kind except "Interior Master" needs the anchor as Ref#1 to lock spatial consistency. Generate it from the Anchor tab first.',
  "drama.sceneV2.kinds.gen": "Generate this kind (4-cell)",
  "drama.sceneV2.kinds.regen": "Regenerate this kind (4-cell)",
  "drama.sceneV2.kinds.genStarted": "Generation submitted",
  "drama.sceneV2.kinds.genFailed": "Generation failed",
  "drama.sceneV2.kinds.errCanonicalNotReady":
    "This kind requires a scene anchor first. Go to the Anchor tab and generate it, then retry.",
  "drama.sceneV2.kinds.needCanonical": "Generate the scene anchor first",

  "drama.sceneV2.extra.tipTitle": "Extra views — append any angle on demand",
  "drama.sceneV2.extra.tipDesc":
    'Describe any angle the four standard views miss, e.g. "looking at the dining table from the kitchen doorway". LLM repaints with the anchor as Ref#1, keeping the same physical space.',
  "drama.sceneV2.extra.addBtn": "Add extra view",
  "drama.sceneV2.extra.empty":
    "No extra views yet. Click above to add the first one.",
  "drama.sceneV2.extra.modalTitle": "Add extra view",
  "drama.sceneV2.extra.formName": "Name (optional)",
  "drama.sceneV2.extra.formNamePlaceholder": "e.g. View from kitchen doorway",
  "drama.sceneV2.extra.formDesc": "Angle description",
  "drama.sceneV2.extra.formDescPlaceholder":
    "e.g. Looking at the dining table from the kitchen doorway, door frame in foreground, full table in mid-ground; key light from the living room window.",
  "drama.sceneV2.extra.formDescRequired": "Describe the angle you want",
  "drama.sceneV2.extra.submit": "Submit",
  "drama.sceneV2.extra.processing": "Generating…",
  "drama.sceneV2.extra.deleteConfirm": "Delete this extra view?",
  "drama.sceneV2.extra.deleteOk": "Deleted",
  "drama.sceneV2.extra.deleteFailed": "Delete failed",
  "drama.sceneV2.extra.genStarted": "Submitted; generating",
  "drama.sceneV2.extra.genFailed": "Generation failed",

  "drama.sceneV2.panorama.tipTitle":
    "Panorama — spatial ground truth for any virtual camera angle",
  "drama.sceneV2.panorama.tipDesc":
    "Upload or generate a 2:1 equirectangular panorama. The virtual camera lets you drag yaw/pitch/fov to slice any perspective view. Sliced views can be used directly as continuity refs for storyboard frames — space stays locked, never drifts.",
  "drama.sceneV2.panorama.previewTitle": "Current panorama",
  "drama.sceneV2.panorama.empty": "No panorama yet",
  "drama.sceneV2.panorama.processing": "Generating…",
  "drama.sceneV2.panorama.upload": "Upload panorama",
  "drama.sceneV2.panorama.replaceUpload": "Replace panorama",
  "drama.sceneV2.panorama.uploadOk": "Upload OK",
  "drama.sceneV2.panorama.uploadFailed": "Upload failed",
  "drama.sceneV2.panorama.fileTooLarge": "File exceeds 64 MB",
  "drama.sceneV2.panorama.cameraTitle": "Virtual camera — slice any view",
  "drama.sceneV2.panorama.yaw": "Yaw",
  "drama.sceneV2.panorama.pitch": "Pitch",
  "drama.sceneV2.panorama.fov": "FoV",
  "drama.sceneV2.panorama.rerender": "Re-render",
  "drama.sceneV2.panorama.renderFailed": "Render failed",
  "drama.sceneV2.panorama.saveAsExtra": "Save as extra view",
  "drama.sceneV2.panorama.saveModalTitle": "Save current view as extra view",
  "drama.sceneV2.panorama.saveOk": "Saved",
  "drama.sceneV2.panorama.saveFailed": "Save failed",
  "drama.sceneV2.panorama.saveYpf":
    "Current camera: yaw {yaw}° / pitch {pitch}° / fov {fov}°",
  "drama.scenes.editModalTitle": "Edit Scene · {name}",
  "drama.scenes.formLabel.name": "Scene Name",
  "drama.scenes.formError.nameRequired": "Scene name is required",
  "drama.scenes.formLabel.description": "Scene Deprojection",
  "drama.scenes.formTooltip.description":
    "LLM uses this when generating the four-view. Regenerate after editing for it to take effect.",
  "drama.scenes.formLabel.era": "Era",
  "drama.scenes.formPlaceholder.era": "e.g. 1980s",
  "drama.scenes.formLabel.timeOfDay": "Time of Day",
  "drama.scenes.formTooltip.timeOfDay":
    "Day / night / dusk; injected into the four-view prompt.",
  "drama.scenes.formPlaceholder.timeOfDay": "e.g. night",
  "drama.scenes.formLabel.lighting": "Lighting",
  "drama.scenes.formTooltip.lighting":
    "Used in the four-view English prompt; e.g. cold fluorescent / warm incandescent",
  "drama.scenes.formPlaceholder.lighting": "e.g. cold fluorescent",
  "drama.scenes.formLabel.keyProps": "Key Props",
  "drama.scenes.formTooltip.keyProps":
    "Press Enter to add each item, injected into the four-view prompt.",
  "drama.scenes.formPlaceholder.tags": "Press Enter to add",
  "drama.scenes.formLabel.styleTags": "Style Tags",
  "drama.scenes.formTooltip.styleTags":
    "Art style tags, injected into the four-view prompt.",

  // ===== Scene detail =====
  "drama.sceneDetail.pageTitle": "Scene Detail",

  // ===== Shots outline (scene-detail left ShotsOutline) =====
  "drama.shotsOutline.title": "Shots",
  "drama.shotsOutline.empty": "No shots yet",
  "drama.shotsOutline.shotLabel": "Shot {shotNo}",
  "drama.shotsOutline.duration": "{sec}s",

  "drama.sceneDetail.notFoundAlert": "Scene not found",
  "drama.sceneDetail.notFoundDesc":
    "Episode {ep} · Scene {scene} does not exist or the project has not been parsed yet.",
  "drama.sceneDetail.stageActionPrefix": "△",
  "drama.sceneDetail.monologueTag": "OS",
  "drama.sceneDetail.narrationTag": "Narration",
  "drama.sceneDetail.cameraTag": "Close-up",
  "drama.sceneDetail.bulletTag": "Bullet",
  "drama.sceneDetail.infoCard": "Scene Info",
  "drama.sceneDetail.label.time": "Time",
  "drama.sceneDetail.label.eventCount": "Events",
  "drama.sceneDetail.label.dialogue": "Dialogue",
  "drama.sceneDetail.label.action": "Action",
  "drama.sceneDetail.label.camera": "Close-up",
  "drama.sceneDetail.label.monologue": "Monologue",
  "drama.sceneDetail.label.narration": "Narration",
  "drama.sceneDetail.label.bullet": "Bullet",
  "drama.sceneDetail.label.characters": "Characters",
  "drama.sceneDetail.label.props": "Props",
  "drama.sceneDetail.label.rawTextLen": "Raw Length",
  "drama.sceneDetail.label.appearingCharacters": "Appearing characters:",
  "drama.sceneDetail.label.propsList": "Props:",
  "drama.sceneDetail.label.emotionalTone": "Emotional tone:",
  "drama.sceneDetail.label.dramaticBeat": "Dramatic beat:",
  "drama.sceneDetail.label.subtext": "Subtext:",
  "drama.sceneDetail.label.plot": "Plot:",
  "drama.sceneDetail.headerEpScene": "Episode {epNo} · {sceneNo}",
  "drama.sceneDetail.locationEmpty": "-",
  "drama.sceneDetail.projectOriginalCard": "Original Project (in order)",
  "drama.sceneDetail.noEvents": "No events in this scene",
  "drama.sceneDetail.rawTextCollapse": "Raw text snippet (verbatim)",

  // ===== Episodes =====
  "drama.episodes.emptyHint":
    'Not split yet. Go to "Overview" first to run LLM split.',
  "drama.episodes.summary": "{episodeCount} episodes / {sceneCount} scenes",
  "drama.episodes.episodeNo": "Episode {epNo}",
  "drama.episodes.outline.title": "Outline",
  "drama.episodes.outline.modeEp": "Ep",
  "drama.episodes.outline.modeEpScene": "Ep + Scene",
  "drama.episodes.sceneCount": "{count} scenes",
  "drama.episodes.errorDetail": "Error detail",
  "drama.episodes.noScenes":
    "No scenes in this episode (parse may have failed; raw text still visible).",
  "drama.episodes.detailButton": "Detail",
  "drama.episodes.storyboardingTag": "Storyboarding",
  "drama.episodes.storyboardFailedTag": "Storyboard Failed",
  "drama.episodes.storyboardedTag": "Storyboarded · {count} shots",
  "drama.episodes.parseFailedTag": "Parse Failed",
  "drama.episodes.parsePartialTag": "Partial{pct}",
  "drama.episodes.parsePartialPct": " · {pct}",
  "drama.episodes.fallbackTitle": "Project",
  "drama.episodes.appearList": "Cast: {names}",
  "drama.episodes.rawTextCollapse": "View raw text (parse failed fallback)",

  // ===== Project editor console (workspace/project.tsx) =====
  "drama.projectText.importDocx": "Import docx",
  "drama.projectText.charCount": "{count} chars",
  "drama.projectText.docxEmpty": "docx parsed empty, please check file content",
  "drama.projectText.docxImported": "Imported {count} characters",
  "drama.projectText.docxFailed": "docx parse failed: {reason}",
  "drama.project.metaEpisodes": "eps",
  "drama.project.metaScenes": "scenes",
  "drama.project.metaCharacters": "cast",
  "drama.project.statusLines": "{count} lines",
  "drama.project.statusEditing": "Editing",
  "drama.project.statusParsing": "Parsing",
  "drama.project.statusUpdated": "Updated {time}",
  "drama.project.outline.title": "Episodes / Scenes",
  "drama.project.outline.empty":
    "Not parsed yet — split episodes in Overview first",
  "drama.project.outline.reparseTooltip":
    "Re-parse this episode (after editing the project body)",
  "drama.project.outline.reparseFailed": "Re-parse failed",
  "drama.project.outline.reparseQueued":
    "Re-parse queued for ep {epNo} (~10-30s in background)",
  "drama.project.outline.reparseEditingBlock":
    "Save or cancel your edits first — re-parse uses the persisted body.",

  // ===== Parse-quality banner (workspace/project.tsx top) =====
  "drama.project.quality.epsRatio": "Parsed {actual}/{planned} episodes",
  "drama.project.quality.missingEps": "{count} episode(s) likely missing",
  "drama.project.quality.failedEps": "Failed: ep {eps}",
  "drama.project.quality.partialEps": "Partial: ep {eps}",
  "drama.project.quality.reparseAbnormal": "Re-parse all abnormal ({count})",
  "drama.project.quality.reparseAbnormalSuccess":
    "Queued re-parse for {count} episode(s) (~30-90s)",
  "drama.project.quality.reparseAbnormalFailed":
    "Re-parse abnormal episodes failed",
  "drama.project.quality.tip":
    'Editing the body clears this banner. For missing episodes, fix the "Episode X" markers in the body and re-parse.',

  // ===== Autosave + version history =====
  "drama.project.autosave.idle": "Autosave",
  "drama.project.autosave.dirty": "Editing…",
  "drama.project.autosave.saving": "Saving…",
  "drama.project.autosave.saved": "Saved · {ago}",
  "drama.project.autosave.justNow": "just now",
  "drama.project.autosave.secondsAgo": "{sec}s ago",
  "drama.project.autosave.minutesAgo": "{min}m ago",
  "drama.project.autosave.failed": "Save failed — click to retry",
  "drama.project.autosave.disabledParsing": "Parsing — autosave paused",
  "drama.project.autosave.disabledNoAccess": "Read only",
  "drama.project.history.openButton": "History",
  "drama.project.history.markButton": "Save checkpoint",
  "drama.project.editor.drawerTitle": "Edit project",
  "drama.project.editor.emptyContent":
    "No project content yet. Upload a .docx or paste the text in the “Project” tab first.",
  "drama.canvas.projectEditor.close": "Collapse project editor",
  "drama.canvas.sidebar.close": "Collapse sidebar",
  "drama.canvas.sidebar.expand": "Expand sidebar",
  "drama.project.history.markPlaceholder": "Optional label for this version",
  "drama.project.history.markOk": "Saved as v{version}",
  "drama.project.history.markFailed": "Failed to save version",
  "drama.project.history.drawerTitle": "Version history",
  "drama.project.history.drawerEmpty": "No snapshots yet",
  "drama.project.history.colVersion": "Version",
  "drama.project.history.colWho": "Author",
  "drama.project.history.colTrigger": "Source",
  "drama.project.history.colChars": "Chars",
  "drama.project.history.colTime": "Time",
  "drama.project.history.colActions": "Actions",
  "drama.project.history.actionCompare": "Diff",
  "drama.project.history.actionRevert": "Revert",
  "drama.project.history.trigger.auto_idle": "Auto",
  "drama.project.history.trigger.auto_threshold": "Checkpoint",
  "drama.project.history.trigger.exit": "On leave",
  "drama.project.history.trigger.manual": "Manual",
  "drama.project.history.trigger.revert": "Revert backup",
  "drama.project.history.delta.add": "+{count}",
  "drama.project.history.delta.del": "−{count}",
  "drama.project.history.compareTitle": "Compare v{version} with current",
  "drama.project.history.compareLoading": "Loading…",
  "drama.project.history.compareLoadFailed": "Failed to load revision",
  "drama.project.history.revertConfirmTitle": "Revert to v{version}?",
  "drama.project.history.revertConfirmContent":
    'The current body will be replaced by v{version}. Existing characters / scenes / storyboards stay, but will be marked as "from a stale version" — you decide whether to re-extract. The current body is auto-saved as a new revision before the revert, so you can roll back again.',
  "drama.project.history.revertConfirmOk": "Revert",
  "drama.project.history.revertConfirmCancel": "Cancel",
  "drama.project.history.revertOk": "Reverted to v{version}",
  "drama.project.history.revertFailed": "Revert failed",
  "drama.project.history.staleHint":
    "Project was reverted — this item may be inconsistent with the current body",
  "drama.project.history.diffHintTooltip":
    "Yellow gutter marks lines changed since the last autosave; cleared on save.",

  // ===== Asset dock =====
  "drama.shotQueueDock.title": "Asset Dock",

  // ===== Import dialog =====
  "drama.importDialog.titleBatch": "Save current folder to my gallery",
  "drama.importDialog.titleBatchCount":
    "Save current folder ({count} items) to my gallery",
  "drama.importDialog.titleSingle": "Save to my gallery",
  "drama.importDialog.titleSingleName": "Save to my gallery ({name})",
  "drama.importDialog.okText": "Start import",
  "drama.importDialog.folderLabel": "Folder",
  "drama.importDialog.folderTooltip":
    "Leave blank for default; pick an existing folder or create a new one.",
  "drama.importDialog.folderPlaceholder": "Pick a folder or create new",
  "drama.importDialog.notesLabel": "Notes",
  "drama.importDialog.notesPlaceholder":
    "Optional: usage notes, shot description, etc.",
  "drama.importDialog.tagsLabel": "Tags",
  "drama.importDialog.tagsPlaceholder": "Press Enter to add multiple tags",

  // ===== Prompt templates =====
  "drama.prompts.pageTitle": "Prompt Templates",
  "drama.prompts.refreshButton": "Refresh",
  "drama.prompts.noCategories": "No configurable prompt categories yet",
  "drama.prompts.loadCategoriesFailed": "Failed to load categories",
  "drama.prompts.loadFailed": "Failed to load",
  "drama.prompts.emptyContentHint":
    'Content cannot be empty. Use "Restore default" to clear.',
  "drama.prompts.saveFailed": "Failed to save",
  "drama.prompts.saveSuccess": "Saved as your version",
  "drama.prompts.resetFailed": "Failed to reset",
  "drama.prompts.resetSuccess": "Restored to default",
  "drama.prompts.fillDefaultInfo": "Editor filled with default (not yet saved)",
  "drama.prompts.fillDefaultButton": "Fill with Default",
  "drama.prompts.modalCancel": "Cancel",
  "drama.prompts.saveButton": "Save as My Version",
  "drama.prompts.columnName": "Name",
  "drama.prompts.columnDeprojection": "Deprojection",
  "drama.prompts.columnLength": "Length",
  "drama.prompts.columnUpdateTime": "Updated",
  "drama.prompts.columnActions": "Actions",
  "drama.prompts.charCount": "{count} chars",
  "drama.prompts.defaultTag": "Default",
  "drama.prompts.modifiedTag": "Customized",
  "drama.prompts.unmodifiedTag": "Unmodified",
  "drama.prompts.editButtonModified": "Edit",
  "drama.prompts.editButton": "Modify",
  "drama.prompts.resetConfirm": "Restore default?",
  "drama.prompts.resetConfirmDesc":
    "This deletes your customization for this prompt and reverts to the built-in default.",
  "drama.prompts.resetOk": "Restore",
  "drama.prompts.resetButton": "Restore Default",
  "drama.prompts.categoryDefaultBadge": "Category default",
  "drama.prompts.unmodifiedHint": "Showing the default value",
  "drama.prompts.variablesTitle":
    "Available placeholders (auto-replaced by backend, please keep)",
  "drama.prompts.textareaPlaceholder":
    "LLM system prompt — affects all calls in this category",
  "drama.prompts.charStatsLength": "Current {count} chars",
  "drama.prompts.charStatsDefault": "· default {count} chars",
  "drama.prompts.charStatsSameAsDefault": " (same as default)",
  "drama.prompts.modalEditTitle": "Edit — {name}",
  "drama.prompts.unmodifiedHintFull": "Unmodified → showing default",
  "drama.prompts.dashPlaceholder": "—",
  "drama.prompts.category.storyboard": "Storyboard director",
  "drama.prompts.category.extract_characters": "Extract characters",
  "drama.prompts.category.extract_scenes": "Extract scenes",
  "drama.prompts.category.character_prompts": "Derived character prompts",
  "drama.prompts.category.detect_episode_marker": "Detect episode marker",
  "drama.prompts.category.character_sheet": "Character sheet generation",
  "drama.prompts.category.scene_sheet": "Scene sheet generation",
  "drama.prompts.category.shot_frame": "Shot frame generation",

  // ===== Workspace components =====
  // Import dialog
  "drama.import.dialogTitle": "Import to Workflow",
  "drama.import.confirmButton": "Import",
  "drama.import.cancelButton": "Cancel",
  "drama.import.successTip": "Imported",
  "drama.import.failedTip": "Failed to import",
  "drama.import.workflowLabel": "Workflow Template",
  "drama.import.workflowPlaceholder": "Select a workflow",
  "drama.import.targetSlotLabel": "Target Slot",
  "drama.import.firstFrame": "First Frame",
  "drama.import.middleFrame": "Middle Frame",
  "drama.import.lastFrame": "Last Frame",
  "drama.import.refImageLabel": "Reference Image",

  // Shot queue dock
  "drama.shotQueue.assetPanelAlt": "Asset Panel",
  "drama.shotQueue.assetPanelTitle": "Asset Panel",
  "drama.shotQueue.queueTab": "Dispatch Queue",
  "drama.shotQueue.galleryTab": "Outputs",
  "drama.shotQueue.empty": "No tasks",
  "drama.shotQueue.cancelAll": "Clear",

  // Outputs gallery
  "drama.gallery.source.all": "All sources",
  "drama.gallery.source.characterShot": "Character shot",
  "drama.gallery.source.characterSheet": "Character sheet",
  "drama.gallery.source.storyboardFrame": "Storyboard frame",
  "drama.gallery.source.canvasImage": "Canvas image",
  "drama.gallery.source.canvasVideo": "Canvas video",
  "drama.gallery.source.canvasAudio": "Canvas audio",
  "drama.gallery.source.storyboardAudio": "Shot audio",
  "drama.gallery.sourceLabel.characterShot": "Shot",
  "drama.gallery.sourceLabel.characterSheet": "Sheet",
  "drama.gallery.sourceLabel.storyboardFrame": "Frame",
  "drama.gallery.sourceLabel.canvasImage": "Canvas img",
  "drama.gallery.sourceLabel.canvasVideo": "Canvas vid",
  "drama.gallery.sourceLabel.canvasAudio": "Canvas TTS",
  "drama.gallery.sourceLabel.storyboardAudio": "Shot TTS",
  "drama.gallery.scope.project": "This project",
  "drama.gallery.scope.all": "All",
  "drama.gallery.cachedTag": "cached",
  "drama.gallery.emptyHint": "No outputs yet",
  "drama.gallery.loadFailed": "Failed to load outputs",
  "drama.gallery.subtitle.storyboardFrame":
    "EP{epNo} S{sceneNo} Shot{shotNo} {slot}",
  "drama.gallery.subtitle.sheet": "Sheet",
  "drama.gallery.subtitle.characterShot": "Shot",

  // Storyboard panel
  "drama.storyboard.cellLabel.wide": "Wide",
  "drama.storyboard.cellLabel.master": "Master",
  "drama.storyboard.cellLabel.front": "Front",
  "drama.storyboard.cellLabel.reverse": "Reverse",
  "drama.storyboard.cellLabel.closeup": "Close-up",
  "drama.storyboard.slotLabel.first": "First",
  "drama.storyboard.slotLabel.middle": "Middle",
  "drama.storyboard.slotLabel.last": "Last",
  // Cinema language four dims (shot_size / angle / movement / shot_role)
  "drama.storyboard.shotSize.ecu": "Extreme close-up",
  "drama.storyboard.shotSize.cu": "Close-up",
  "drama.storyboard.shotSize.mcu": "Medium close-up",
  "drama.storyboard.shotSize.ms": "Medium shot",
  "drama.storyboard.shotSize.mls": "Medium long shot",
  "drama.storyboard.shotSize.ls": "Long shot",
  "drama.storyboard.shotSize.els": "Extreme long shot",
  "drama.storyboard.shotSize.overTheShoulder": "Over the shoulder",
  "drama.storyboard.shotSize.twoShot": "Two-shot",
  "drama.storyboard.shotSize.insert": "Insert",
  "drama.storyboard.angle.eyeLevel": "Eye level",
  "drama.storyboard.angle.high": "High angle",
  "drama.storyboard.angle.low": "Low angle",
  "drama.storyboard.angle.dutch": "Dutch angle",
  "drama.storyboard.angle.overhead": "Overhead",
  "drama.storyboard.angle.pov": "POV",
  "drama.storyboard.movement.static": "Static",
  "drama.storyboard.movement.pan": "Pan",
  "drama.storyboard.movement.tilt": "Tilt",
  "drama.storyboard.movement.dollyIn": "Dolly in",
  "drama.storyboard.movement.dollyOut": "Dolly out",
  "drama.storyboard.movement.handheld": "Handheld",
  "drama.storyboard.movement.crane": "Crane",
  "drama.storyboard.movement.track": "Tracking",
  "drama.storyboard.shotRole.dialog": "Dialogue",
  "drama.storyboard.shotRole.master": "Master",
  "drama.storyboard.shotRole.reaction": "Reaction",
  "drama.storyboard.shotRole.insert": "Insert",
  "drama.storyboard.shotRole.cutaway": "Cutaway",
  "drama.storyboard.shotRole.pov": "POV",
  "drama.storyboard.shotRole.reveal": "Reveal",
  "drama.storyboard.shotRole.beat": "Beat",
  "drama.storyboard.cinemaDim.shotSize": "Shot size",
  "drama.storyboard.cinemaDim.angle": "Angle",
  "drama.storyboard.cinemaDim.movement": "Movement",
  "drama.storyboard.cinemaDim.shotRole": "Shot role",
  "drama.storyboard.shotLabel": "Shot {shotNo}",
  "drama.storyboard.dispatchButton": "Dispatch",
  "drama.storyboard.dispatchSuccess": "Dispatched",
  "drama.storyboard.dispatchFailed": "Failed to dispatch",
  "drama.storyboard.regenButton": "Regenerate",
  "drama.storyboard.importButton": "Import to Workflow",
  "drama.storyboard.uploadButton": "Upload Replace",
  "drama.storyboard.deleteButton": "Delete",
  "drama.storyboard.frameMissing": "Frame missing",

  // ===== Storyboard panel (components/StoryboardPanel.tsx) =====
  // FrameSlotCell
  "drama.storyboard.frameStatus.generating": "Generating",
  "drama.storyboard.frameStatus.failed": "Failed",
  "drama.storyboard.frameStatus.notGenerated": "Not generated",
  "drama.storyboard.frameStatus.failedDefault": "Generation failed",
  "drama.storyboard.frameStatus.deleteFrame": "Delete this frame",

  // ShotFrameDrawer
  "drama.storyboard.refDrawer.titleWithShot": "Reference setup · Shot {shotNo}",
  "drama.storyboard.refDrawer.title": "Reference setup",
  "drama.storyboard.refDrawer.submit": "Generate",
  "drama.storyboard.refDrawer.sceneRefTitle": "Scene reference (Ref#2)",
  "drama.storyboard.refDrawer.sceneRefOverridden":
    "Continuity image picked → first-frame scene cell is ignored (middle/last still use it)",
  "drama.storyboard.refDrawer.sceneRefEmptyMsg":
    "No generated scene sheets yet",
  "drama.storyboard.refDrawer.sceneRefEmptyDesc":
    "Generate the four-view scene sheet on the Scenes page first.",
  "drama.storyboard.refDrawer.sceneRefNone":
    "No scene reference (text-to-image only)",
  "drama.storyboard.refDrawer.viewKeyTitle": "View (view_key)",
  "drama.storyboard.refDrawer.viewKeyHint":
    "Click a thumbnail to pick; leave blank = let the model read the full sheet",
  "drama.storyboard.refDrawer.charRefTitle":
    "Extra references (Ref#1, character canonical)",
  "drama.storyboard.refDrawer.charRefEmpty":
    "No characters with canonical images yet. Generate them on the Characters page.",
  "drama.storyboard.refDrawer.charRefSelected":
    "Selected {count} characters (max {max}; Ref# order follows pick order)",
  "drama.storyboard.refDrawer.framePromptTitle": "Caption / shot supplement",
  "drama.storyboard.refDrawer.framePromptPlaceholder":
    'Optional. e.g. "Close-up of Jiang He raising eyes; light slants in from the window." Leave blank to use the LLM-written shot description.',
  "drama.storyboard.refDrawer.framesTitle": "Frames to generate",
  "drama.storyboard.refDrawer.frameFirst":
    "First frame (required, used as the keyframe for video)",
  "drama.storyboard.refDrawer.frameMiddle": "Middle frame",
  "drama.storyboard.refDrawer.frameLast": "Last frame",
  "drama.storyboard.refDrawer.force": "Force regenerate (overwrite completed)",

  // ContinuityImage (Ref#1 picker card + modal)
  "drama.continuity.title": "Continuity reference (Ref#1)",
  "drama.continuity.subtitle":
    "Optional. Affects only the first frame; replaces the scene cell.",
  "drama.continuity.pickEmpty": "Pick a continuity reference image",
  "drama.continuity.pickHint":
    "Choose from a frame in this scene or from the asset library",
  "drama.continuity.change": "Change",
  "drama.continuity.changeTooltip": "Click to change",
  "drama.continuity.clear": "Clear",
  "drama.continuity.cardCaption.shotFrame": "Shot {shotNo} · {slot}",
  "drama.continuity.cardCaption.externalImport": "Asset library",
  "drama.continuity.cardCaption.sceneCanonical": "Scene anchor",
  "drama.continuity.cardCaption.sceneExtra": "Scene extra view",
  "drama.continuity.cardCaption.panoramaView":
    "Panorama · yaw {yaw}° / pitch {pitch}°",
  "drama.continuity.picker.title": "Pick continuity reference",
  "drama.continuity.picker.tab.project": "Project outputs",
  "drama.continuity.picker.tab.asset": "Asset library",
  "drama.continuity.picker.scope.current": "This scene",
  "drama.continuity.picker.scope.all": "All my outputs",
  "drama.continuity.picker.scene.empty":
    "No frame is available in this scene yet. Generate at least one shot frame first.",
  "drama.continuity.picker.all.empty":
    "No project frames yet. Generate first/middle/last frames in any storyboard first.",
  "drama.continuity.picker.all.epLabel": "Ep {epNo}",
  "drama.continuity.picker.scene.caption": "Shot {shotNo} · {slot}",
  "drama.continuity.picker.scene.slotFirst": "First",
  "drama.continuity.picker.scene.slotMiddle": "Middle",
  "drama.continuity.picker.scene.slotLast": "Last",
  "drama.continuity.picker.asset.empty":
    "No image asset yet. Save assets via My Gallery.",
  // ==== Picker — Scene Views / Panorama tabs ====
  "drama.continuity.picker.tab.scene": "Scene views",
  "drama.continuity.picker.tab.panorama": "Panorama",
  "drama.continuity.picker.scene.emptyV2":
    'No scene anchor or extra views yet. Generate them from the scene\'s "Visual Consistency V2" drawer first.',
  "drama.continuity.picker.scene.canonicalCaption": "{name} · Anchor",
  "drama.continuity.picker.scene.canonicalSubtitle": "Scene ground truth",
  "drama.continuity.picker.scene.extraDefaultCaption": "Extra view",
  "drama.continuity.picker.panorama.empty":
    'No panorama available. Upload or generate one from any scene\'s "Visual Consistency V2" drawer first.',
  "drama.continuity.picker.panorama.sceneLabel": "Scene:",
  "drama.continuity.picker.panorama.scenePlaceholder": "Pick a scene",
  "drama.continuity.picker.panorama.selectFirst": "Pick a scene first",
  "drama.continuity.picker.panorama.yaw": "Yaw",
  "drama.continuity.picker.panorama.pitch": "Pitch",
  "drama.continuity.picker.panorama.fov": "FoV",
  "drama.continuity.picker.panorama.rerender": "Re-render",
  "drama.continuity.picker.panorama.pick": "Use this angle",
  "drama.continuity.picker.panorama.repick": "Selected · Pick again",
  "drama.continuity.picker.panorama.curParams":
    "Current: yaw {yaw}° / pitch {pitch}° / fov {fov}°",

  // VideoPromptBlock
  "drama.storyboard.video.defaultTpl": "Default template",
  "drama.storyboard.video.title": "Video prompt",
  "drama.storyboard.video.countSummary": "{count} entries",
  "drama.storyboard.video.partialInFlight": " · partial in flight",
  "drama.storyboard.video.notGenerated": "Not generated",
  "drama.storyboard.video.needFirstFrame": "First frame needed",
  "drama.storyboard.video.tooltipMore":
    "Pick templates to add more entries or regenerate",
  "drama.storyboard.video.tooltipFirst":
    "Pick templates to generate the video prompt",
  "drama.storyboard.video.tooltipNeedFirstFrame":
    "Generate the first frame first",
  "drama.storyboard.video.regenMore": "Generate more / regen",
  "drama.storyboard.video.generate": "Generate prompt",
  "drama.storyboard.video.tagPrimary": "Primary",
  "drama.storyboard.video.tagCharCount": "· {count} chars",
  "drama.storyboard.video.statusReady": "Ready · {sec}s",
  "drama.storyboard.video.statusFailed": "Failed",
  "drama.storyboard.video.statusInFlight": "Generating",
  "drama.storyboard.video.statusQueued": "Queued",
  "drama.storyboard.video.actionCopy": "Copy",
  "drama.storyboard.video.actionSetPrimary": "Set primary",
  "drama.storyboard.video.actionRetry": "Retry",
  "drama.storyboard.video.actionDeleteEntry": "Delete this entry",
  "drama.storyboard.video.alertFailed": "LLM failed",
  "drama.storyboard.video.modalTitle": "Generate video prompt",
  "drama.storyboard.video.modalOkForce": "Force regenerate selected",
  "drama.storyboard.video.modalOkStart": "Start generation",
  "drama.storyboard.video.modalDesc":
    "You can pick multiple templates at once; backend runs them concurrently (soft cap 3 per shot). Each template = one prompt entry. The first to finish becomes primary; you can switch or delete on the entry card.",
  "drama.storyboard.video.modalSelectTpl": "Select templates",
  "drama.storyboard.video.modalNoTpl":
    "No templates available; system default will be used.",
  "drama.storyboard.video.tplBuiltinSuffix": "{name} · built-in",
  "drama.storyboard.video.tplExists": "Exists",
  "drama.storyboard.video.tplCatAction": "Action-only",
  "drama.storyboard.video.tplCatZhPlain": "Chinese plain",
  "drama.storyboard.video.tplCatEnStructured": "Structured English",
  "drama.storyboard.video.tplSearchPh":
    "Search templates (name / description / tag)",
  "drama.storyboard.video.tplSearchEmpty": "No matching templates",
  "drama.storyboard.video.modalDefaultHint":
    "No template ticked = system default (LTX-2.3 i2v). Your selection is remembered for next time.",
  "drama.storyboard.video.modalForce":
    "Force regenerate (overwrite existing entries of the same template)",
  "drama.storyboard.video.modalForceHint":
    "All ticked templates already have entries; enable force-regen to overwrite.",
  // toasts in VideoPromptBlock
  "drama.storyboard.video.copySuccess": "Copied to clipboard",
  "drama.storyboard.video.copyFailed": "Copy failed; please select manually",
  "drama.storyboard.video.setPrimarySuccess": "Switched primary",
  "drama.storyboard.video.setPrimaryFailed": "Failed to set primary",
  "drama.storyboard.video.deleteInFlight": "In progress; cannot delete",
  "drama.storyboard.video.deleteConfirmTitle":
    'Delete the prompt for "{name}"?',
  "drama.storyboard.video.deleteConfirmPrimary":
    "This entry is currently primary; the system will switch to another completed entry (if any) after deletion.",
  "drama.storyboard.video.deleteConfirmDefault": "This cannot be undone.",
  "drama.storyboard.video.deleteOk": "Delete",
  "drama.storyboard.video.deleteSuccess": 'Deleted "{name}"',
  "drama.storyboard.video.deleteFailed": "Failed to delete",
  "drama.storyboard.video.retrySuccess": "Re-dispatched",
  "drama.storyboard.video.submitFailed": "Failed to submit",
  "drama.storyboard.video.dispatchSuccess":
    "Dispatched {count} prompt entries; LLM is generating…",
  "drama.storyboard.video.alreadyLatest": "Already up to date; no regen needed",

  // ShotCard
  "drama.storyboard.shotCard.shotLabel": "Shot {shotNo}",
  "drama.storyboard.shotCard.expandDetails": "Details",
  "drama.storyboard.shotCard.collapseDetails": "Collapse",
  "drama.storyboard.shotGrid.noContent": "(no content)",
  "drama.storyboard.shotCard.subjects": "Cast: {names}",
  "drama.storyboard.shotCard.composition": "Composition: {value}",
  "drama.storyboard.shotCard.framePanelTitle": "Frames",
  "drama.storyboard.shotCard.scenePrefix": "Scene: ",
  "drama.storyboard.shotCard.charactersPrefix": "Characters: ",
  "drama.storyboard.shotCard.downloadFrames": "Download frames",
  "drama.storyboard.shotCard.configGenerate": "Configure / generate",
  "drama.storyboard.shotCard.dispatchedSlots": "Dispatched {labels}",
  "drama.storyboard.shotCard.configSaved": "Config saved",
  "drama.storyboard.shotCard.submitFailed": "Failed to submit",
  "drama.storyboard.shotCard.noDownloadable": "No downloadable frames",
  "drama.storyboard.shotCard.downloadAllSuccess": "Downloaded {count} frames",
  "drama.storyboard.shotCard.downloadAllFailed":
    "Failed to download {count} frames",
  "drama.storyboard.shotCard.downloadPartial":
    "Downloaded {success}, failed {failed}",
  "drama.storyboard.shotCard.deleteFrameTitle": "Delete {slotLabel}?",
  "drama.storyboard.shotCard.deleteFrameContent":
    'This cannot be undone. To regenerate, use "Configure / generate" again.',
  "drama.storyboard.shotCard.deleteFrameOk": "Delete",
  "drama.storyboard.shotCard.deleteFrameCancel": "Cancel",
  "drama.storyboard.shotCard.deleteFrameSuccess": "Deleted {slotLabel}",
  "drama.storyboard.shotCard.deleteFrameFailed": "Failed to delete",

  // Main panel
  "drama.storyboard.panel.cardTitle": "Storyboard",
  "drama.storyboard.panel.empty": "No storyboard for this scene yet",
  "drama.storyboard.panel.generateButton": "Generate storyboard",
  "drama.storyboard.panel.statusInFlight": "Generating",
  "drama.storyboard.panel.statusFailed": "Failed",
  "drama.storyboard.panel.statusPartial": "Partial",
  "drama.storyboard.panel.statusReady": "Ready",
  "drama.storyboard.panel.shotsCount": "{count} shots",
  "drama.storyboard.panel.durationApprox": "~{value}",
  "drama.storyboard.panel.durationApproxTarget": "~{value} / target {target}s",
  "drama.storyboard.panel.coverage": "Coverage {pct}%",
  "drama.storyboard.panel.importButton": "Import to Workflow",
  "drama.storyboard.panel.menuRegen": "Regenerate",
  "drama.storyboard.panel.menuDelete": "Delete",
  "drama.storyboard.panel.deleteConfirmTitle": "Delete this storyboard?",
  "drama.storyboard.panel.deleteConfirmContent": "You can regenerate it later.",
  "drama.storyboard.panel.deleteOk": "Delete",
  "drama.storyboard.panel.deleteCancel": "Cancel",
  "drama.storyboard.panel.deleteSuccess": "Deleted",
  "drama.storyboard.panel.deleteFailed": "Failed to delete",
  "drama.storyboard.panel.inFlightTitle": "LLM is generating, usually 10–30s",
  "drama.storyboard.panel.inFlightDesc":
    "Async task; safe to leave the page — come back later to view.",
  "drama.storyboard.panel.intent": "Intent: {value}",
  "drama.storyboard.panel.failedTitle": "LLM generation failed",
  "drama.storyboard.panel.failedFallback": 'Click "Regenerate" to retry',
  "drama.storyboard.panel.partialTitle": "Coverage {pct}% is low",
  "drama.storyboard.panel.partialDesc":
    "LLM missed parts of the original text; tweak the target duration and regenerate.",
  "drama.storyboard.panel.noShots": "No shots",
  "drama.storyboard.panel.viewList": "List",
  "drama.storyboard.panel.viewGrid": "Grid",
  "drama.storyboard.panel.viewTimeline": "Timeline",
  "drama.storyboard.panel.expandAll": "Expand all",
  "drama.storyboard.panel.collapseAll": "Collapse all",
  "drama.storyboard.panel.searchPlaceholder":
    "Search shot / beat / dialogue / action",
  "drama.storyboard.panel.filterAll": "All",
  "drama.storyboard.panel.filterNoFrame": "Missing frames",
  "drama.storyboard.panel.filterCompleted": "Completed",
  "drama.storyboard.panel.matchCount": "Matched {matched}/{total}",
  "drama.storyboard.panel.filterEmpty": "No shots match current filters",
  "drama.storyboard.panel.modalTitleRegen": "Regenerate storyboard",
  "drama.storyboard.panel.modalTitleNew": "Generate storyboard",
  "drama.storyboard.panel.modalOkRegen": "Regenerate",
  "drama.storyboard.panel.modalOkStart": "Start generation",
  "drama.storyboard.panel.modalCancel": "Cancel",
  "drama.storyboard.panel.modalDesc":
    "LLM picks the shot count, durations, and cinematic language; usually returns in 10–30s. Async — leaving the page is fine.",
  "drama.storyboard.panel.modalDescRegenSuffix":
    "Regenerating overwrites the current storyboard.",
  "drama.storyboard.panel.targetSec": "Target duration",
  "drama.storyboard.panel.targetSecPlaceholder": "Auto",
  "drama.storyboard.panel.targetSecAddon": "sec",
  "drama.storyboard.panel.targetSecHint":
    "Empty / 0 = fully adaptive, LLM decides; >0 = converges within ±15% of the target.",
  "drama.storyboard.panel.toastFailed": "Storyboard generation failed",
  "drama.storyboard.panel.toastPartialCoverage":
    "Storyboard generated, but coverage {pct}% is low",
  "drama.storyboard.panel.toastReady": "Generated {count} shots",
  "drama.storyboard.panel.submitFailed": "Failed to submit",

  // ===== Outputs gallery (components/OutputsGalleryTab.tsx) =====
  "drama.outputsGallery.tab.project": "Project Outputs",
  "drama.outputsGallery.tab.mine": "My Gallery",
  "drama.outputsGallery.subtitle.sheetFallback": "sheet",
  "drama.outputsGallery.totalCount": "{count} in total",
  "drama.outputsGallery.deleteTooltip": "Delete this image",
  "drama.outputsGallery.deleteConfirmTitle": "Delete this entry?",
  "drama.outputsGallery.deleteConfirmDesc":
    "MinIO file is preserved (kept as a forensic trail). Only this record is removed. In-flight frames cannot be deleted.",
  "drama.outputsGallery.deleteOk": "Delete",
  "drama.outputsGallery.deleteSuccess": "Deleted",
  "drama.outputsGallery.deleteFailed": "Failed to delete",

  // ===== My gallery (components/MyGalleryPanel.tsx) =====
  "drama.myGallery.storage.label": "Storage",
  "drama.myGallery.storage.fileCount":
    "{count, plural, =0 {no files} one {# file} other {# files}}",
  "drama.myGallery.storage.kind.import": "My library",
  "drama.myGallery.storage.kind.canvas_image": "Canvas image",
  "drama.myGallery.storage.kind.canvas_video": "Canvas video",
  "drama.myGallery.storage.kind.canvas_audio": "Canvas audio",
  "drama.myGallery.storage.kind.storyboard_audio": "Shot audio",
  "drama.myGallery.category.all": "All",
  "drama.myGallery.category.image": "Image",
  "drama.myGallery.category.video": "Video",
  "drama.myGallery.category.other": "Other",
  "drama.myGallery.status.all": "All statuses",
  "drama.myGallery.status.processing": "Processing",
  "drama.myGallery.status.completed": "Completed",
  "drama.myGallery.status.failed": "Failed",
  "drama.myGallery.statusLabel.pending": "Pending",
  "drama.myGallery.statusLabel.processing": "Importing",
  "drama.myGallery.statusLabel.completed": "Completed",
  "drama.myGallery.statusLabel.failed": "Failed",
  "drama.myGallery.folderPlaceholder": "Folder",
  "drama.myGallery.folderAll": "All folders",
  "drama.myGallery.searchPlaceholder": "Search name / notes / tags",
  "drama.myGallery.totalCount": "{count} in total",
  "drama.myGallery.loadFailed": "Failed to load My Gallery",
  "drama.myGallery.empty": "No imports yet",
  "drama.myGallery.processingTip": "Importing",
  "drama.myGallery.failedDefault": "Failed",
  "drama.myGallery.fileTypeFile": "FILE",
  "drama.myGallery.tooltipEdit": "Edit",
  "drama.myGallery.tooltipDownload": "Download",
  "drama.myGallery.tooltipDelete": "Delete",
  "drama.myGallery.deleteConfirmTitle": "Delete this import record?",
  "drama.myGallery.deleteConfirmDesc":
    "The MinIO object is preserved; only the Mongo record is removed.",
  "drama.myGallery.deleteOk": "Delete",
  "drama.myGallery.deleteSuccess": "Deleted",
  "drama.myGallery.deleteFailed": "Failed to delete",
  "drama.myGallery.saveSuccess": "Saved",
  "drama.myGallery.saveFailed": "Failed to save",
  "drama.myGallery.editTitle": "Edit: {name}",
  "drama.myGallery.editFolderLabel": "Folder",
  "drama.myGallery.editFolderPlaceholder": "Pick an existing folder or create",
  "drama.myGallery.editNotesLabel": "Notes",
  "drama.myGallery.editTagsLabel": "Tags",
  "drama.myGallery.editTagsPlaceholder": "Press Enter to add multiple tags",
  "drama.myGallery.videoClose": "Close",
  "drama.myGallery.videoDownload": "Download",

  // ============ Project collaboration ============
  // workspace.tab.members has no entry point (members live in the ProjectMembersMenu Popover top-right);
  // key kept to avoid stray references breaking.
  "drama.workspace.tab.members": "Members",
  "drama.members.menu.tooltip": "Collaboration",
  "drama.members.menu.manage": "Manage members", // legacy key kept (unused), defensive
  "drama.members.share.addPeople": "Add members",
  "drama.members.share.emailPlaceholder": "Enter email…",
  "drama.members.share.messagePlaceholder": "Message (optional)",
  "drama.members.share.send": "Invite",
  "drama.members.share.addMessage": "+ Add message",
  "drama.members.share.whoHasAccess": "Who has access",
  "drama.members.menu.setEditor": "Set as Editor",
  "drama.members.menu.setViewer": "Set as Viewer",
  "drama.members.tab.list": "Members",
  "drama.members.tab.pending": "Pending invites",
  "drama.members.empty": 'No members yet. Click "Invite" to add someone.',
  "drama.members.invitations.empty": "No pending invites",
  "drama.members.you": "You",
  "drama.members.role.owner": "Owner",
  "drama.members.role.editor": "Editor",
  "drama.members.role.viewer": "Viewer",
  "drama.members.action.invite": "Invite",
  "drama.members.action.transfer": "Transfer ownership",
  "drama.members.action.remove": "Remove",
  "drama.members.action.leave": "Leave",
  "drama.members.action.revoke": "Revoke",
  "drama.members.confirm.remove": "Remove this member from the project?",
  "drama.members.confirm.leave": "Leave this collaboration?",
  "drama.members.confirm.revoke": "Revoke this pending invite?",
  "drama.members.table.user": "User",
  "drama.members.table.role": "Role",
  "drama.members.table.joined": "Joined",
  "drama.members.table.actions": "Actions",
  "drama.members.invitations.email": "Email",
  "drama.members.invitations.expireAt": "Expires at",
  "drama.members.toast.added": "Added. Notification email sent.",
  "drama.members.toast.invited": "Invitation email sent.",
  "drama.members.toast.lookupFailed":
    "Email not registered or lookup failed. Invitation link sent.",
  "drama.members.toast.roleUpdated": "Role updated",
  "drama.members.toast.removed": "Removed",
  "drama.members.toast.revoked": "Revoked",
  "drama.members.toast.transferred": "Ownership transferred",
  "drama.members.modal.send": "Send invite",
  "drama.members.modal.email": "Email",
  "drama.members.modal.emailRequired": "Please enter an email",
  "drama.members.modal.emailInvalid": "Invalid email format",
  "drama.members.modal.role": "Role",
  "drama.members.modal.message": "Message (optional)",
  "drama.members.modal.messagePlaceholder": "A short note to the invitee",
  "drama.members.modal.hint":
    "Registered users will be added directly and notified by email; unregistered users will receive an invitation link to accept after signing up.",
  "drama.members.transfer.title": "Transfer ownership",
  "drama.members.transfer.warning":
    'After transfer you will become "Editor", and only the new owner can transfer back. Confirm carefully.',
  "drama.members.transfer.placeholder": "Select an editor",
  "drama.members.transfer.confirm": "Confirm transfer",

  // Accept invitation page
  "drama.invitation.lede": "{inviter} invited you to collaborate on a project",
  "drama.invitation.role": "Role:",
  "drama.invitation.invitee": "Invitation sent to:",
  "drama.invitation.expireAt": "Expires at:",
  "drama.invitation.message": "Message",
  "drama.invitation.acceptingAs": 'Accepting as "{user}"',
  "drama.invitation.accept": "Accept invitation",
  "drama.invitation.later": "Later",
  "drama.invitation.gotoProjects": "Back to my projects",
  "drama.invitation.error.notFound": "Invitation not found or expired",
  "drama.invitation.error.selfInvite": "You are the sender of this invitation",
  "drama.invitation.error.generic": "Failed to handle invitation",

  // ===== Collaboration (viewer-mode UI hints) =====
  "drama.collab.tooltipReadOnly":
    "You are a viewer and cannot perform this action. Ask the project owner to promote you to editor.",
  "drama.collab.bannerViewer":
    "You are browsing this project as a viewer — read-only; all write actions are disabled.",
  "drama.collab.bannerViewerExtra":
    "Need to collaborate? Ask the owner to promote you to editor.",
  "drama.collab.errInsufficientRole":
    "Permission denied: this action requires editor role or above",
  "drama.collab.errNoProjectAccess":
    "You no longer have access to this project, redirecting to projects list",
};
